import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";

interface SnsLinkProps {
    className?: string;
}

export default function SnsLink({ className }: SnsLinkProps) {
    return (
        <ul className={twMerge("flex items-center gap-[40px]", className)}>
            <li>
                <Link
                    to="https://www.instagram.com/gxg_gameculture/"
                    target="_blank"
                    className="font-0 block size-[28px] bg-icInsta bg-cover -indent-[9999px]"
                >
                    인스타그램
                </Link>
            </li>
            <li>
                <Link
                    to="https://www.facebook.com/people/GXG_gameculture/100094975943247/"
                    target="_blank"
                    className="font-0 block size-[28px] bg-icFacebook bg-cover -indent-[9999px]"
                >
                    페이스북
                </Link>
            </li>
            <li>
                <Link
                    to="https://www.youtube.com/@GXG_gameculture"
                    target="_blank"
                    className="font-0 block size-[28px] bg-icYoutube bg-cover -indent-[9999px]"
                >
                    유튜브
                </Link>
            </li>
            <li>
                <Link to={`/`} className="font-0 block size-[28px] bg-icHome bg-cover -indent-[9999px]">
                    홈
                </Link>
            </li>
        </ul>
    );
}
